import { Link, useNavigate } from 'react-router-dom';
import { SITELINK } from '../../app-routes/Links';
import { useFetchUnreadNotifications } from '../../api-services/notifications/useFetchUnreadNotifications';
import { LuChevronLeft } from 'react-icons/lu';
import { useTheme } from '../../context/theme-context';

// main-component-ui
type TopBarProps = {
  title: string;
  link?: string; // Make link optional
  goBack?: boolean; // New prop to control back navigation
  onBack?: () => void; // Optional custom back handler
};

const TopBar = ({ title, link, goBack = false, onBack }: TopBarProps) => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const unread_notification = useFetchUnreadNotifications();

  const handleBack = () => {
    if (onBack) {
      onBack(); // Use custom handler if provided
    } else if (goBack) {
      navigate(-1); // Go back one step in browser history
    }
  };

  const hasBackAction = goBack || onBack;
  const hasLink = !!link;

  const renderBackButton = () => {
    // If we have a link, render as Link component
    if (hasLink && !hasBackAction) {
      return (
        <Link to={link!} className="font-semibold text-sm flex">
          <LuChevronLeft className="text-2xl mt-[2px]" />
        </Link>
      );
    }
    
    // If we have back navigation, render as button
    if (hasBackAction) {
      return (
        <button
          onClick={handleBack}
          className="font-semibold text-sm flex hover:opacity-70 transition-opacity"
          aria-label="Go back"
        >
          <LuChevronLeft className="text-2xl mt-[2px]" />
        </button>
      );
    }
    
    // Fallback: render disabled or invisible placeholder to maintain layout
    return <div className="w-6" />;
  };

  return (
    <>
      <div className="flex items-center justify-between pr-3 pl-2 py-3 bg-white dark:bg-neutral-800">
        <div className="flex gap-4 relative">
          {renderBackButton()}
          <p className="font-medium madimi-one">{title}</p>
        </div>
        <div className="text-black text-[1.5rem] pt-1 flex gap-5">
          <Link to={SITELINK.NOTIFICATIONS} className="relative">
            <>
              <svg
                width="20"
                height="20"
                viewBox="0 0 13 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.40313 12.8125C4.53815 13.2637 4.8151 13.6593 5.19286 13.9406C5.57062 14.2218 6.02903 14.3738 6.5 14.3738C6.97097 14.3738 7.42938 14.2218 7.80714 13.9406C8.1849 13.6593 8.46185 13.2637 8.59687 12.8125H4.40313ZM0.875 12.1875H12.125V10.3125L10.875 8.4375V5.3125C10.875 4.73797 10.7618 4.16906 10.542 3.63826C10.3221 3.10746 9.99985 2.62516 9.59359 2.21891C9.18734 1.81265 8.70504 1.49039 8.17424 1.27053C7.64344 1.05066 7.07453 0.9375 6.5 0.9375C5.92547 0.9375 5.35656 1.05066 4.82576 1.27053C4.29496 1.49039 3.81266 1.81265 3.40641 2.21891C3.00015 2.62516 2.67789 3.10746 2.45803 3.63826C2.23816 4.16906 2.125 4.73797 2.125 5.3125V8.4375L0.875 10.3125V12.1875Z"
                  fill={isDarkMode ? "white" : "black"}
                />
              </svg>
            </>
            {unread_notification?.data?.length === 0 && (
              <span className="notification-pointer"></span>
            )}
          </Link>
        </div>
      </div>
    </>
  );
};

export default TopBar;